import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
})
export class TermsAndConditionsComponent {
  location = inject(Location);
  protected readonly feUtil = inject(FeUtil);

}
